import { initMultipleSlider } from 'application/shared/sliders'

_require ['canonical_selector_v4'], ->
  initMultipleSlider()

  $('.js-canonical-selector').prop('disabled', false)
  canonicalSelect = new QB.CanonicalSelectorV4()
  canonicalSelect.init('.js-canonical-selector', { idVal: 1 })
